import React from "react";
import ReactDOM from "react-dom";
import Popup from 'react-popup';
import "bootstrap/dist/css/bootstrap.css";
import "./assests/scss/index.scss";
import 'emoji-mart/css/emoji-mart.css'
import { Provider } from "react-redux";
import store from "./store";
import actionCable from "actioncable"
import 'react-image-lightbox/style.css'; // This only needs to be imported once in your app

import App from "./App";
import * as serviceWorker from "./serviceWorker";
import axios from "axios";
import { apiBaseURL, cableURL } from "./utils/utils";

const baseURL = apiBaseURL();
const wsURL = cableURL();

axios.defaults.baseURL = baseURL

const userToken = JSON.parse(sessionStorage.getItem("userToken"));
if (userToken != null) {
  const AuthStr = "Bearer ".concat(userToken);
  axios.defaults.headers.common["Authorization"] = AuthStr;
}

if (process.env.NODE_ENV !== "production") {
  axios.interceptors.request.use(
    request => {
      // Edit request config
      return request;
    },
    error => {
      console.log(error);
      return Promise.reject(error);
    }
  );

  axios.interceptors.response.use(
    response => {
      // Edit request config
      return response;
    },
    error => {
      console.log(error);
      return Promise.reject(error);
    }
  );
}


const CableApp = {};
CableApp.cable = actionCable.createConsumer(`${wsURL}/cable`)

ReactDOM.render(
  <Provider store={store}>
    <App cable={CableApp.cable}/>
  </Provider>,
  document.getElementById("root")
);

ReactDOM.render(
    <Popup />,
    document.getElementById('popupContainer')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
